import BeaconAction from '@tencent/beacon-web-sdk';
import { getBrowser, getOS } from './utils';

class Statistic extends BeaconAction {
  constructor(options) {
    super(options);
    try {
      this.sendPageInit();
      this.enterTime = new Date().getTime();
      if (options.spa) {
        this.spaInit();
      }

      window.addEventListener('beforeunload', () => {
        try {
          const leaveTime = new Date().getTime();
          const stayTime = parseInt((leaveTime - this.enterTime) / 1000, 10);
          this.sendOnlineTime(stayTime);
        } catch (err) {
          console.error(err);
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  sendPageInit() {
    try {
      const current = this._formatUrl();
      const referer = this._formatUrl(document.referrer);

      const data = {
        url: `${current.protocol}//${current.host}${current.pathname}`,
        referrer: `${referer.protocol}//${referer.host}${referer.pathname}`,
        os: getOS(),
        browser: getBrowser(),
        scr: this._getScreenRadio()
      };

      if (current.param && current.param.ADTAG) {
        data.adtag = current.param.ADTAG;
      }

      this.onDirectUserAction('pageInit', data);
    } catch (error) {
      console.error(error);
    }
  }

  sendOnlineTime(stayTime) {
    const current = this._formatUrl();
    this.onDirectUserAction('online', {
      url: `${current.protocol}//${current.host}${current.pathname}`,
      onlineTime: stayTime
    });
  }

  spaInit() {
    history.pushState = this.wr('pushState') || history.pushState;
    history.replaceState = this.wr('replaceState') || history.replaceState;

    const [firedUrl] = location.href.split('?');
    this.$fireUrl = firedUrl;

    this.onPageChange();
  }

  onPageChange() {
    this.sendPv = this.sendPv.bind(this);
    window.addEventListener('replaceState', this.sendPv);
    window.addEventListener('pushState', this.sendPv);
    window.addEventListener('popstate', this.sendPv);
  }

  wr(type) {
    const origin = history[type];
    if (typeof origin !== 'function' || !/native code/.test(origin.toString())) {
      return false;
    }
    const self = this;
    return function () {
      // 发送在线时长
      const leaveTime = new Date().getTime();
      const stayTime = parseInt((leaveTime - self.enterTime) / 1000, 10);
      self.sendOnlineTime(stayTime);
      self.enterTime = leaveTime;

      const res = origin.apply(this, arguments);
      let event = null;
      if (typeof Event === 'function') {
        event = new Event(type);
      } else {
        // 兼容ie
        event = document.createEvent('HTMLEvents');
        event.initEvent(type, false, true);
      }
      window.dispatchEvent(event);
      return res;
    };
  }

  sendPv() {
    // 避免 replaceState + pushState 在一个页面内一起用时造成重复收集。
    // 两个方法实际只会产生一个效果，而我们只需要最终效果，中间 url 不会有渲染逻辑，应该被丢掉
    // 使用 setTimeout 保证在最终完成 url 变更只会才执行内部操作，参考 https://github.com/googleanalytics/autotrack/blob/master/lib/plugins/url-change-tracker.js#L115
    setTimeout(() => {
      const [firedUrl] = location.href.split('?');

      // 如果 url 并没有发生变化时，没有必要上报
      if (!firedUrl || firedUrl === this.$fireUrl) {
        return;
      }

      // 发送PV
      this.sendPageInit();

      // 记录最新 url
      this.$fireUrl = firedUrl;
    }, 0);
  }

  _getScreenRadio() {
    const { screen } = window;
    return `${screen.width}x${screen.height}`;
  }

  _formatUrl(url = '') {
    const { location } = window;
    if (!url) {
      return {
        protocol: location.protocol,
        host: location.hostname,
        pathname: location.pathname,
        search: location.search.substr(1),
        hash: location.hash,
        param: this._getSearchParam(location.search.substr(1))
      };
    }

    const match = url.match(/\w+:\/\/((?:[\w-]+\.)+\w+)(?::\d+)?(\/[^?\\"'|:<>]*)?(?:\?([^'"\\<>#]*))?(?:#(\w+))?/i) || [];
    return {
      protocol: url.indexOf('https') !== -1 ? 'https:' : 'http:',
      host: match[1],
      pathname: match[2],
      search: match[3],
      hash: match[4],
      param: this._getSearchParam(match[3])
    };
  }

  _getSearchParam(search) {
    if (!search) return null;
    const param = {};
    search.split('&').forEach(item => {
      const [key, value] = item.split('=');
      param[key] = value;
    });
    return param;
  }

  onSendBeacon(eventCode, params) {
    if (navigator.sendBeacon && typeof navigator.sendBeacon === 'function') {
      super.onSendBeacon(eventCode, params);
    } else {
      super.onDirectUserAction(eventCode, params);
    }
  }
}

export default Statistic;
